import Cookies from 'js-cookie';

const handler = ($) => {

	// submit filters form on dropdown change
	$('.resources-hub-filters select').on( 'change', function( e ) {
		e.preventDefault();
		$(this).parents('form').submit();
	});

	// clear search also should submit the form
	$('.resources-hub-filters .clear-search').on( 'click', function( e ) {
		$(this).parents('form').submit();
	});

	// submit filters form on search KeyUp
	let timeout = null;
	$('.resources-hub-filters input[type=text]').on( 'keyup paste', function() {

		const $form = $(this).parents('form');

		clearTimeout(timeout);
		timeout = setTimeout(function () {
			$form.submit();
		}, 300 );

	});

	// do the filters
	$('.resources-hub-filters').on('submit', function( e ) {
		e.preventDefault();

		const $form = $(this),
		$postsHolder = $form.parents('.resources-hub-block').find('.posts'),
		$loadMoreLinkHolder = $form.parents('.resources-hub-block').find('.ajax-pagination-load-more'),
		$loadMoreLink = $loadMoreLinkHolder.find('.ajax-load-more-link');

		let search = $form.find('input[type=text]').length ? $.trim( $form.find('input[type=text]').val() ) : '',
		resource_category = $form.find('select[name=resource_category]').length ? $.trim( $form.find('select[name=resource_category]').val() ) : '',
		resource_type = $form.find('select[name=resource_type]').length ? $.trim( $form.find('select[name=resource_type]').val() ) : '',
		resource_city = $form.find('select[name=resource_city]').length ? $.trim( $form.find('select[name=resource_city]').val() ) : '',
		resource_topic = $form.find('select[name=resource_topic]').length ? $.trim( $form.find('select[name=resource_topic]').val() ) : '',
		resource_collection = $form.find('select[name=resource_collection]').length ? $.trim( $form.find('select[name=resource_collection]').val() ) : '',

		default_term_id = $form.find('input[name=default_term_id]').val(),
		default_tax = $form.find('input[name=default_tax]').val();

		$.ajax( {
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'fp_filter_resources_posts',
				nonce: Cookies.get( 'wordpress_pen_ajax_nonce' ),
				search: search,
				resource_category: resource_category,
				resource_type: resource_type,
				resource_city: resource_city,
				resource_topic: resource_topic,
				resource_collection: resource_collection,
				default_term_id: default_term_id,
				default_tax: default_tax
			},
			beforeSend: function () {
				$postsHolder.addClass( 'is-loading' );
			},
			success: function ( answer ) {

				if ( answer.hide_link ) {
					$loadMoreLink.hide();
				} else {
					$loadMoreLink.show();
				}

				if ( answer.no_results ) {
					$postsHolder.addClass('is-no-results'); 
				} else {
					$postsHolder.removeClass('is-no-results');
				}

				$postsHolder.removeClass( 'is-loading' ).html( answer.html );

				$loadMoreLink.attr(
					'data-current-query',
					JSON.stringify( answer.query )
				);

			}
		});

	});

};

export default (($) => $(handler))(jQuery);
